import { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import _ from 'lodash';
import { Link } from 'react-router-dom';

// material
import {
  Card, Button, DialogContent, DialogContentText, DialogActions, Typography, Grid, Switch, MenuItem, CardHeader, Box,
  TextField, Select, Stack, CardActionArea, ListItemText, Checkbox,
} from '@mui/material';
import { decodedToken } from "../../../utils/Reusables";
import { DecryptData } from "../../../utils/encryptDecrypt";
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import IconButton from '@mui/material/IconButton';
import { ReactComponent as AngleDownIcon } from '../../../assets/icons/icon-angle-down.svg';
import EditIcon from "../../../assets/icons/icon_edit.svg";
import ChartIcon from '../../chartIcon'
import Popup from '../../Popup';
// utils
import FavouriteIcon from '../../../assets/icons/icon_favorite.svg';
import FavouriteFilledIcon from '../../../assets/icons/icon_favorite_filled.svg';
import ViewIcon from '../../../assets/icons/icon_view.svg';
import ShareIcon from '../../../assets/icons/icon_share.svg';
import TrashIcon from '../../../assets/icons/icon_trash.svg';
import toast from 'react-hot-toast';
import { ReactComponent as DropDownIcon } from "../../../assets/icons/icon-angle-down.svg"
import { makeStyles } from '@mui/styles'
import { useNavigate } from 'react-router-dom';

import { ReportCardTitleLength, ReportCardDescriptionLength } from "../../../constants/stringParams";
import { handleStringLength } from "../../../utils/multiLangDashboardV2Data";
import { dashboardShare, userTypeShare } from '../../../config/services/dashboardShare';



// ----------------------------------------------------------------------
DashboardCard.propTypes = {
  dashboard: PropTypes.object
};

const useStyles = makeStyles((theme) => ({
  actionArea: {
    "&:hover $focusHighlight": {
      opacity: 0
    }
  },
  focusHighlight: {},
  btnIcon: {
    boxShadow: 'none',
    backgroundColor: 'transparent',
    borderRadius: 0,
    "&:focus, &.Mui-focusVisible, &:active": {
      boxShadow: 'none',
      backgroundColor: 'transparent',
      borderRadius: 0,
    },
  }
}));

export default function DashboardCard({ dashboard, handleFavrtDashboard, handleDeactivateDashboard, handleDeleteDashboard, handleShareDashboard, handleEditDashboard, userTypeList, pageNo }) {
  const currentRole = DecryptData(localStorage.getItem('role'))
  const currentUser = DecryptData(localStorage.getItem('s_uuid'))
  let { dashboardDescription, dashboardName, updatedAt, isFavourite, isDeactivated, isPublished, _id, sheets, sharedWith, currentAccess, schoolCodes } = dashboard;
  if (currentRole === 'superadmin') currentAccess = 'edit'
  const [openPopupDeactivateDashboard, setOpenPopupDeactivateDashboard] = useState(false);
  const [shareProps, setShareProps] = useState({ props: { userType: [] } })
  const [openSharePopup, setOpenSharePopup] = useState(false)
  const classes = useStyles();
  const navigate = useNavigate();
 

  const calAllReportsInDash = (sheets) => {
    let totalRepoorts = 0
    sheets?.map(sheet => {
      totalRepoorts = totalRepoorts + sheet?.reports?.length
      return sheet
    })
    return totalRepoorts
  }

  let NoOfReports = calAllReportsInDash(sheets)

  const handleSharePopup = () => {
    const seletedUserTypeName = sharedWith.map((item) => userTypeList.find((userType) => userType._id === item.usertypeId)?.userTypeName);
    
    setShareProps({ props: { userType: seletedUserTypeName } })
    setOpenSharePopup(true)
  }

  const handleDeactivate = (e, dashboard) => {
    if (!isDeactivated && isPublished) {
      setOpenPopupDeactivateDashboard(true);
    } else {
      handleDeactivateDashboard(e, dashboard)
    }
  }

  const handleDeactivatePublishDashboard = async (type) => {
    if (type === "deactivate") {
      let e = { target: { checked: false } };
      handleDeactivateDashboard(e, dashboard)
    }
    setOpenPopupDeactivateDashboard(false);
  }

  const handleCancelShareDashboard = () => {
    setShareProps({ props: {} })
    setOpenSharePopup(false)
  }

  const validateEmail = (email) => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  // const getCurrentUserId = () => {
  //   let currentUserId;
  //   currentUserId = DecryptData(localStorage.getItem('s_uuid')) 
  //   if(!currentUserId) {
  //      currentUserId = DecryptData(localStorage.getItem('uuid')) 
  //   }
  //   return currentUserId
  // }

  const handleSaveShareDashboard = async () => {
   
    if (shareProps?.props && !Object.keys(shareProps?.props).length) {
      toast.error('All fields are required')
      return;
    }
    if (!shareProps?.props?.shareType) {
      toast.error('Share With is required');
      return;
    }
    if (shareProps?.props?.shareType === 'user' && !shareProps?.props?.email) {
      toast.error('User Email is required');
      return;
    }
    if (shareProps?.props?.shareType && shareProps?.props?.shareType != 'none' && !shareProps?.props?.accessType) {
      toast.error('User Access is required');
      return;
    }
    if ((shareProps?.props?.shareType === 'role' && !shareProps?.props?.role)
      || shareProps?.props?.shareType === 'userType' && (!shareProps?.props?.userType || (shareProps?.props?.userType && !shareProps?.props?.userType.length))) {
      toast.error('User Type is required');
      return;
    }
    if (shareProps?.props?.email && !validateEmail(shareProps?.props?.email)) {
      toast.error('Invalid Email Address');
      return;
    }    

    let tempSchoolCodes = []
    if (shareProps?.props?.shareType === 'userType' || shareProps?.props?.shareType === 'role') {
      //Assinging SchoolCode
      const token = localStorage.getItem('accessToken');
      const decoded = decodedToken(token)

      if (decoded && decoded?.school_code) {
        if (Array.isArray(decoded?.school_code) && decoded?.school_code.length) {
          tempSchoolCodes = [...decoded?.school_code]
        }
        else if (!Array.isArray(decoded?.school_code)) {
          tempSchoolCodes.push(decoded?.school_code)
        }
      }

    }

    let updatedSchoolCodes = []
    if (schoolCodes?.length) {
      updatedSchoolCodes = [...new Set([...schoolCodes, ...tempSchoolCodes])]
    }
    else {
      updatedSchoolCodes = [...tempSchoolCodes]
    }
    const userTypeIds = shareProps?.props?.userType?.map((userTypeName) => (userTypeList?.find((userType) => userType?.userTypeName === userTypeName)?._id))

    const deletedUserTypeIds = sharedWith?.reduce((acc, item) => {
      if (!userTypeIds?.includes(item?.usertypeId)) {
        acc.push(item?.usertypeId)
      }
      return acc
    }, []);

    const params = {
      dashboardId: _id,
      usertypeId: userTypeIds,
      accessType: shareProps?.props?.accessType,
      deletedUserTypeId: deletedUserTypeIds ? deletedUserTypeIds : [],
      type: 'dashboard',
      shareType: shareProps?.props?.shareType
      // schoolCodes: updatedSchoolCodes,
      // ...(shareProps?.props?.email && { emailId: shareProps?.props?.email }),
    }


    dashboardShare(params)
      .then((res) => {
        setOpenSharePopup(false)
        toast.success(res.message)
      });

  //     if (shareProps?.props?.shareType === 'none') {
  //     let updatedShareWith = [{}]
  //     params.sharedWith = JSON.stringify(updatedShareWith)
  //   }

  //   handleShareDashboard(params, setOpenSharePopup, setShareProps)
  // 
}


  const handleSelectShareType = (e) => {
    const type = e?.target?.value;
    let shareDetails = _.cloneDeep(shareProps)
    shareDetails.props.shareType = type
    setShareProps(shareDetails)
  }

  const handleRoleSelect = (e) => {
    const { value } = e?.target
    const shareDetails = _.cloneDeep(shareProps)
    shareDetails.props.userType = value
    setShareProps(shareDetails)
  }

  const handleShareAccessType = (e) => {
    let { value } = e.target
    let shareDetails = _.cloneDeep(shareProps)
    shareDetails.props.accessType = value
    setShareProps(shareDetails)
  }

  const handleShareEmail = (e) => {
    let { value } = e.target
    let shareDetails = _.cloneDeep(shareProps)
    shareDetails.props.email = value
    setShareProps(shareDetails)
  }

  const handleDashboardPreview = (dashboard) => {
    //console.log(dashboard)
    let path = `/dashboardView/${dashboard._id}`
    if (dashboard?._id === "Custom_Dashboard") {
      navigate('/custom-report',{state:dashboard})
    }else {
      navigate(path,{state:dashboard})
    }

    //navigate(path)
  }



  return (
    <Card className='dash_card'>
      <CardHeader className="dashboard-card-header"
        action={
          <IconButton onClick={() => handleFavrtDashboard(dashboard)} title="Add To Favorites" className='card-btn-size form_icon'>
            {isFavourite ? <span><img alt='' src={FavouriteFilledIcon} /></span> : <span><img alt='' src={FavouriteIcon} /></span>}
          </IconButton>
        }
        title={<Button variant="text" className="blk_icon card-main-title"
          onClick={() => handleDashboardPreview(dashboard)}
        // onClick={() => (currentAccess !== 'view') ? handleEditDashboard('/reportDashboard/' + _id + '?pageNo=' + pageNo) : navigate(`/dashboardView/${_id}`)}
        //to={"/reportDashboard/" + _id}
        >
          <h3 title={dashboardName}> {handleStringLength(dashboardName, ReportCardTitleLength)} </h3>
        </Button>}
        subheader={
          <span>
            <p className='dash_card_subhead' title={dashboardDescription}> {handleStringLength(dashboardDescription, ReportCardDescriptionLength)}</p>
            <span className='dash_card_sub_color'> {`${NoOfReports} Report${NoOfReports > 1 ? 's' : ''} | Edited: ${moment(updatedAt).fromNow()}`}</span>
          </span>
        }
      />

      <CardActionArea className="report-card-action"
        onClick={() => handleDashboardPreview(dashboard)}
        // onClick={() => (currentAccess !== 'view') ? handleEditDashboard('/reportDashboard/' + _id + '?pageNo=' + pageNo) : navigate(`/dashboardView/${_id}`)}
        //component={Link} to={'/reportGraph/' + report._id}
        classes={{
          root: classes.actionArea,
          focusHighlight: classes.focusHighlight
        }}>
        <CardContent className='cm-card-content dashboard-card-content'>
          <CardMedia
            component="img"
            className="dashboard-card-img"
            src={ChartIcon({ chartType: sheets?.[0]?.reports?.[0]?.reportId?.chartType ?? 'bar' })}
            title={dashboardName}
          />
        </CardContent>
      </CardActionArea>

      <CardContent className='cm-card-content card-footer'>

        <Grid container direction="row" alignItems="center">
          {(currentAccess !== 'view') && dashboard?._id !== "Custom_Dashboard" && (
            <>
              <Grid item className="icon-container">
                <Link className="blk_icon" to="" onClick={() => handleEditDashboard('/reportDashboard/' + _id + '?pageNo=' + pageNo)}>
                  <Box display='flex' alignItems='center' spacing={2} >
                    <img alt='' src={EditIcon} />
                    <Typography ml={1}> Edit</Typography>
                  </Box>
                </Link>
              </Grid>

              {currentRole?.toLowerCase() !== 'teacher' &&
                <Grid item className="icon-container">
                  <Link className="blk_icon" to="" onClick={() => handleSharePopup()}>
                    <Box display='flex' alignItems='center' spacing={2} >
                      <img alt='' src={ShareIcon} />
                      <Typography ml={1}> Share</Typography>
                    </Box>
                  </Link>
                </Grid>
              }
              {
                (currentRole === 'superadmin' || dashboard.createdByDetails.s_uuid == currentUser ) && (
                  <>
                    <Grid item className="icon-container">
                      <Link className="blk_icon" to="" onClick={() => handleDeleteDashboard({ _id, dashboardName })} >
                        <Box display='flex' alignItems='center' spacing={2}>
                          <img alt='' src={TrashIcon} />
                          <Typography ml={1}> Delete</Typography>
                        </Box>
                      </Link>
                    </Grid>
                    <Grid item className="icon-container">
                      <Box display='flex' alignItems='center' className="icon-container">
                        <Switch disableRipple={true} checked={!isDeactivated} onChange={(e) => handleDeactivate(e, dashboard)} color="primary" name="deactivateDashboard" />
                        <Typography> Deactivate </Typography>
                      </Box>
                    </Grid>
                  </>
                )
              }
            </>
          )}
          <Grid item className="icon-container">
            <Link 
              className="blk_icon" 
              onClick={() => handleDashboardPreview(dashboard)} 
              //to={dashboard?._id === 'Custom_Dashboard' ? '/custom-report' : "/dashboardView/" + _id}
            >
              <Box display='flex' alignItems='center' spacing={2} className="icon-container">
                <img alt='' src={ViewIcon} />
                <Typography ml={1}>Preview</Typography>
              </Box>
            </Link>
          </Grid>
        </Grid>
      </CardContent>

      <Popup
        title={<Typography className='text-heading title'>Deactivate Published Dashboard</Typography>}
        openPopup={openPopupDeactivateDashboard}
        setOpenPopup={() => handleDeactivatePublishDashboard('cancel')}
      >
        <DialogContent className="custom-modal-content">
          <DialogContentText>
            Are you Sure you want to Deactivate Published Dashboard
          </DialogContentText>
        </DialogContent>

        <DialogActions className="btn-group">
          <Button onClick={() => handleDeactivatePublishDashboard('cancel')} color="error" className="report_form_ui_btn cancel"> Cancel </Button>
          <Button onClick={() => handleDeactivatePublishDashboard('deactivate')} color="primary" className="report_form_ui_btn submit" autoFocus> Deactivate </Button>
        </DialogActions>
      </Popup>


      {openSharePopup ? <Popup
        title={<Typography className='text-heading title'>Share Dashboard</Typography>}
        openPopup={openSharePopup}
        setOpenPopup={handleCancelShareDashboard}
      >
        <DialogContent className="custom-modal-content">
          <DialogContentText>
            <Box width="100%" height="100%" p="2">
              <Stack
                width="100%"
                spacing={1}
                flexShrink={0}
                sx={{ my: 1 }}
              >
                <Box className="mb-1">
                  <label className='text-small label'>Share With</label>
                  <Select onChange={handleSelectShareType} className="report_form_ui_input_select mt-0"
                    IconComponent={DropDownIcon} value={shareProps?.props?.shareType ?? shareProps?.props?.shareType}>
                    <MenuItem className="menu-item-small" value="none">None</MenuItem>
                    <MenuItem className="menu-item-small" value="userType">UserType</MenuItem>
                  </Select>
                </Box>

                {shareProps?.props?.shareType === 'none' ? null : <Box className="mb-1">
                  <label className='text-small label'>Access</label>
                  <Select onChange={handleShareAccessType} className="report_form_ui_input_select mt-0"
                    IconComponent={DropDownIcon} value={shareProps?.props?.accessType}>
                    <MenuItem className="menu-item-small" value="view">View</MenuItem>
                    <MenuItem className="menu-item-small" value="edit">Edit</MenuItem>
                  </Select>
                </Box>}
                {/* <Button style={{width: '16rem'}} variant="outlined" color="primary">Share</Button>  */}

                {(shareProps?.props?.shareType !== 'none') && (shareProps[0]?.shareType === 'userType' || shareProps?.props?.shareType === 'userType') ? (
                  <Box>
                    <label className='text-small label'>UserType</label>
                    {/* <Select onChange={handleRoleSelect} value={shareProps?.props?.userType} className="report_form_ui_input_select mt-0" >
                      { userTypeList?.map((user, i) => {
                        return (<MenuItem key={i} value={user?.userTypeName}>{user?.userTypeName}</MenuItem>)
                      })}
                    </Select> */}

                    <Select
                      className="report_form_ui_input_select pl-0 text-smal"
                      multiple
                      IconComponent={AngleDownIcon}
                      value={shareProps?.props?.userType ?? []}
                      renderValue={(selected) => selected.join(", ")}
                      onChange={(e) => handleRoleSelect(e)}
                      MenuProps={{
                        anchorOrigin: {
                          vertical: "bottom",
                          horizontal: "left"
                        },
                        transformOrigin: {
                          vertical: "top",
                          horizontal: "left"
                        },
                        getContentAnchorEl: null
                      }}
                    >
                      {
                        userTypeList?.map((data) => (
                          <MenuItem className='menu-item-small' key={data?._id} value={data?.userTypeName}>
                            <Checkbox className="form_checkbox" checked={shareProps?.props?.userType?.indexOf(data?.userTypeName) > -1} />
                            <ListItemText className="text-small" primary={data?.userTypeName} />
                          </MenuItem>
                        ))
                      }
                    </Select>
                  </Box>
                ) : null}

                {shareProps?.props?.shareType === 'user' && (
                  <Box>
                    <label className='text-small label'>Email</label>
                    <TextField className="report_form_ui_input" size="medium" onChange={handleShareEmail} label="Enter Email" value={shareProps?.props?.email} placeholder="Enter Email" />
                  </Box>
                )
                }
              </Stack>

            </Box>
          </DialogContentText>
        </DialogContent>

        <DialogActions className="btn-group" sx={{ mb: 2 }}>
          <Button onClick={() => handleCancelShareDashboard()} color="error" className="report_form_ui_btn cancel"> Cancel </Button>
          <Button onClick={() => handleSaveShareDashboard()} color="primary" autoFocus className="report_form_ui_btn submit"> Done </Button>
        </DialogActions>
      </Popup> : null}

    </Card>
  );
}
